// Braces are `\{+` / `\}+` (1 or more) — LLM output occasionally drops one brace
// (`{{principal_name}` observed 2026-08-26 on Isuru Jayathilaka's touch 1).
export function substituteTokens(body, { firstName, link, personalisedIntro, principalName } = {}) {
  return String(body || '')
    .replace(/\{+\s*first_name\s*\}+/gi, String(firstName || 'there'))
    .replace(/\{+\s*link\s*\}+/gi, String(link || ''))
    .replace(/\{+\s*personalised_intro\s*\}+/gi, String(personalisedIntro || '[Personalised per prospect]'))
    .replace(/\{+\s*principal_name\s*\}+/gi, String(principalName || ''));
}
